<div class="bg-bg-base">
  <section class="relative overflow-hidden py-10">
    <div class="pointer-events-none absolute inset-0 overflow-hidden">
      <div class="absolute -top-40 -right-32 h-80 w-80 rounded-full bg-primary/5 blur-3xl"></div>
      <div
        class="absolute -bottom-40 -left-32 h-80 w-80 rounded-full bg-primary-deep/5 blur-3xl"
      ></div>
    </div>
    <div class="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <!-- Section Header -->
      <div class="mb-16 text-center">
        <h2
          class="mb-4 bg-primary bg-clip-text text-3xl font-bold text-transparent md:text-4xl leading-normal"
        >
          {{ 'home.whyStayAt.title' | translate }}
        </h2>
        <p class="mx-auto max-w-2xl text-lg text-text-secondary">
          {{ 'home.whyStayAt.subtitle' | translate }}
        </p>
      </div>

      <!-- Features Grid -->
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        <!-- Feature Item 1 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-info/10 ring-1 ring-info/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-magnifying-glass text-info text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.smartSearch.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.smartSearch.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 2 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-success/10 ring-1 ring-success/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-shield text-success text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.managedUnits.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.managedUnits.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 3 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-primary/10 ring-1 ring-primary/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-circle-check text-primary text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.accurateData.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.accurateData.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 4 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-warning/10 ring-1 ring-warning/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-house text-warning text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.rentalManagement.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.rentalManagement.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 5 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-danger/10 ring-1 ring-danger/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-users text-danger text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.brokerSystems.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.brokerSystems.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 6 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-success/10 ring-1 ring-success/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-dollar-sign text-success text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.rationalPrices.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.rationalPrices.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 7 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-info/10 ring-1 ring-info/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fa-solid fa-wand-magic-sparkles text-info text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.advancedAI.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.advancedAI.description' | translate }}
            </p>
          </div>
        </div>

        <!-- Feature Item 8 -->
        <div class="group">
          <div
            class="h-full surface-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
          >
            <div class="mb-4">
              <div
                class="inline-flex rounded-xl bg-primary/10 ring-1 ring-primary/20 p-3 shadow-md transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fas fa-chart-line text-primary text-lg"></i>
              </div>
            </div>
            <h3
              class="mb-2 font-semibold text-text-primary transition-colors group-hover:text-primary"
            >
              {{ 'home.whyStayAt.features.analytics.title' | translate }}
            </h3>
            <p class="text-text-secondary text-sm leading-relaxed">
              {{ 'home.whyStayAt.features.analytics.description' | translate }}
            </p>
          </div>
        </div>
      </div>

      <!-- Stats Section -->
      <div
        class="mt-16 rounded-3xl bg-gradient-to-r from-primary to-primary-deep p-8 text-white shadow-xl shadow-primary-glow"
      >
        <div class="grid grid-cols-2 gap-8 text-center md:grid-cols-4">
          <div>
            <div class="mb-2 text-3xl font-semibold">98%</div>
            <div class="text-white/80">{{ 'home.whyStayAt.stats.satisfaction' | translate }}</div>
          </div>
          <div>
            <div class="mb-2 text-3xl font-semibold">24/7</div>
            <div class="text-white/80">{{ 'home.whyStayAt.stats.support' | translate }}</div>
          </div>
          <div>
            <div class="mb-2 text-3xl font-semibold">+500</div>
            <div class="text-white/80">{{ 'home.whyStayAt.stats.partners' | translate }}</div>
          </div>
          <div>
            <div class="mb-2 text-3xl font-semibold">+10K</div>
            <div class="text-white/80">{{ 'home.whyStayAt.stats.transactions' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
